var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTimezone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9468 7.05325C15.5818 5.68825 13.7968 4.99992 12.0002 4.99992V11.9999L7.0535 16.9466C9.7835 19.6766 14.2168 19.6766 16.9585 16.9466C19.6885 14.2166 19.6885 9.78325 16.9468 7.05325ZM12.0002 0.333252C5.56016 0.333252 0.333496 5.55992 0.333496 11.9999C0.333496 18.4399 5.56016 23.6666 12.0002 23.6666C18.4402 23.6666 23.6668 18.4399 23.6668 11.9999C23.6668 5.55992 18.4402 0.333252 12.0002 0.333252ZM12.0002 21.3333C6.8435 21.3333 2.66683 17.1566 2.66683 11.9999C2.66683 6.84325 6.8435 2.66659 12.0002 2.66659C17.1568 2.66659 21.3335 6.84325 21.3335 11.9999C21.3335 17.1566 17.1568 21.3333 12.0002 21.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimezone);
export default __webpack_public_path__ + "static/media/icon_timezone.e7b8de5fe43d4e858366c6a7c50587eb.svg";
export { ForwardRef as ReactComponent };